import { PropsWithChildren } from 'react';
import { TabsTrigger } from '@zep/ui/experimental';
import { cn } from '@zep/utils';
export const PlanTabsTrigger = <T extends string,>({
  className,
  children,
  ...props
}: PropsWithChildren<{
  value: T;
} & React.ComponentPropsWithoutRef<typeof TabsTrigger>>) => {
  return <TabsTrigger {...props} className={cn('w-[139px] m-0 h-[32px] flex justify-center items-center text-body-2 text-gray-600 rounded-[6px] hover:bg-[#27262E14]', 'data-[state=active]:bg-white', 'data-[state=active]:text-gray-900', 'data-[state=active]:shadow-[0_1px_4px_0_rgba(42,39,65,0.08)]', 'data-[state=disabled]:cursor-not-allowed', 'data-[state=disabled]:bg-gray-100', 'data-[state=disabled]:text-gray-400', 'data-[state=disabled]:hover:text-gray-400', className)} data-sentry-element="TabsTrigger" data-sentry-component="PlanTabsTrigger" data-sentry-source-file="PlanTabsTrigger.tsx">
      {children}
    </TabsTrigger>;
};